import React from "react";
import "./PasswordSentModal.css";

const PasswordSentModal = ({ isOpen, onContinue }) => {
  if (!isOpen) return null;

  return (
    <div className="password-sent-modal-overlay">
      <div className="password-sent-modal">
        <div className="password-sent-icon">📧</div>
        <h2 className="password-sent-title">Password Sent!</h2>
        <p className="password-sent-message">
          We've sent a temporary password to your email. Please check your inbox
          and use it to log in.
        </p>
        <button className="password-sent-btn" onClick={onContinue}>
          Go to Login
        </button>
      </div>
    </div>
  );
};

export default PasswordSentModal;
